import { useState } from 'react';
import intl from 'react-intl-universal';
import moment from 'moment';
import classnames from 'classnames';
import {
  Icon,
  Typography,
  Button,
  useElevation,
} from '@getsynapse/design-system';
import { DATE } from 'utils/constants';
import UnarchiveRequestModal from './UnarchiveRequestModal';

type ArchivedRequestBannerProps = {
  archiveDate: string;
  sidePanel?: boolean;
  canUnarchive: boolean;
  requestId: string;
};

const ArchivedRequestBanner = ({
  archiveDate,
  sidePanel = false,
  canUnarchive = false,
  requestId,
}: ArchivedRequestBannerProps) => {
  const elevation = useElevation(2);
  const [isUnarchiveModalOpen, setIsUnarchiveModalOpen] =
    useState<boolean>(false);

  return (
    <div
      className={classnames('mb-6 rounded-sm', elevation, sidePanel && 'mt-1')}
      data-testid='request-archived-banner'
    >
      <UnarchiveRequestModal
        isOpen={isUnarchiveModalOpen}
        setIsOpen={setIsUnarchiveModalOpen}
        requestId={requestId}
        sidePanel={sidePanel}
      />
      <div className='shadow-archived-banner py-4 px-6 flex'>
        <Icon name='archive' className='text-purple-dark w-6 h-6' />
        <div className='flex justify-between w-full'>
          <div className='ml-4'>
            <Typography variant='h6'>
              {intl.get('REQUEST_PAGE.ARCHIVED_REQUEST_BANNER.TITLE')}
            </Typography>
            <Typography>
              {intl.get('REQUEST_PAGE.ARCHIVED_REQUEST_BANNER.BODY', {
                archiveDate: moment(archiveDate).format(DATE.SHORT_FORMAT),
              })}
            </Typography>
          </div>
          <div>
            {canUnarchive && (
              <Button
                variant='secondary'
                onClick={() => setIsUnarchiveModalOpen(true)}
              >
                {intl.get('REQUEST_PAGE.ARCHIVED_REQUEST_BANNER.BUTTON')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchivedRequestBanner;
